/*
  dow
*/
/**
* Deal of the week Management
*/
//-- init

function dow_script() {
  /************************************************
         MOBILE CTA DISPLAY/HIDE
  *************************************************/

  //== get dow box
  var dow_box = $("[class^=desk_block_hding_img_2_inline_list] .dow");

  // //== hide it if empty and show placeholder modules
  if (dow_box.find("a").length === 0 && dow_box.find("img").length === 0) {
    dow_box.parents("[data-type=module]").hide();
    $("[data-type=module][data-nodow]").show();
  }
  else {
    $("[data-type=module][data-nodow]").hide();
  }


  /************************************************
         DISPLAY COUNTER
  *************************************************/
  var Affiche = document.getElementById("dow_cpt");

  function Rebour() {

    var importdate = document.getElementById("vraidate").innerHTML;
    var date1 = new Date();
    var date2 = new Date (importdate);
    var sec = (date2 - date1) / 1000;
    var n = 24 * 3600;
    var img = " ";

    if (sec > 0) {

      j = Math.floor (sec / n);
      h = Math.floor ((sec - (j * n)) / 3600);
      mn = Math.floor ((sec - ((j * n + h * 3600))) / 60);
      sec = Math.floor (sec - ((j * n + h * 3600 + mn * 60)));

      var separator = '<div class="separator">:</div>';
      var wrapper_start = '<div class="dow-timer-wrapper">';
      var wrapper_end = '</div>';
      var j_block = '<div class="col"><div class="number days">'+j+'</div><div class="name" data-action="edit-text">days</div> </div>';
      var h_block = '<div class="col"> <div class="number hours">'+h+'</div><div class="name" data-action="edit-text">hrs</div></div>';
      var mn_block = '<div class="col"><div class="number minutes">'+mn+'</div><div class="name" data-action="edit-text">min</div></div>';
      var sec_block = '<div class="col"><div class="number seconds">'+sec+'</div><div class="name" data-action="edit-text">sec</div></div>';

      if (j >= 1) {
        result = j_block + separator + h_block + separator + mn_block + separator + sec_block;
      }
      else if (h >= 1) {
        result = h_block + separator + mn_block + separator + sec_block;
      }
      else if (mn >= 1) {
        result = mn_block + separator + sec_block;
      }
      else {
        result = sec_block;
      }


      Affiche.innerHTML = wrapper_start + result + wrapper_end;
    }

    tRebour=setTimeout (function() { Rebour(); }, 1000);
  }
  Rebour();
}

//-- delay DOW script execution due to <script> dow exec
if (PAGE_CODE === "hmp_in" && ($(".dow").find("a").length !== 0 || $(".dow").find("img").length !== 0)) {
  setTimeout(function() { dow_script(); }, 2000);
}
